// extracted by css-extract-rspack-plugin
export default {"cls1":"LettersModal-cls1_7Ns","cls2":"LettersModal-cls2_8Rh LettersModal-cls1_7Ns"};